module.exports = __webpack_public_path__ + "static/img/news4.5bbcd4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4.jpg
// module id = FTxp
// module chunks = 1